var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"csr-cp-checkout"},[(_setup.isShow)?_c('button',{class:['csr-cp-checkout_btn', _vm.dataset.className],attrs:{"disabled":_setup.isDisabled},on:{"click":_setup.checkOut}},[_vm._v(_vm._s(_vm.dataset.buttonLabel || _vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }